module.exports = __webpack_public_path__ + "img/strategy-dashboard.87d7c19c.jpg";